import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Validators, FormGroup } from "@angular/forms";
import { BaseStepComponent } from "../../../base/base-step.component";
import { PrestarContaEvento } from "../../../entity/prestar-conta-evento";
import { JustificarEvento } from "../../../entity/justificar-evento";
import { PrestarContaEventoInstrutor } from "../../../entity/prestar-conta-evento-instrutor";
import { AnexoPrestacaoConta } from "../../../entity/anexo-prestacao-conta.model";
import { ValidCpfORCnpj } from "../../../util/custom.validators";
import * as FileSaver from "file-saver";
import { Situacoes } from "../../../entity/enumeraveis";
import { Edicao } from "../../../entity/edicao-model";
@Component({
  selector: "evento-prestacao-conta-etapa5",
  templateUrl: "./evento-prestacao-conta-etapa5.component.html",
})
export class CrudEventoPrestacaoContaEtapa5Component extends BaseStepComponent {
  instrucao: any[];
  displayIntrutorModal: boolean;
  @Input() listaConteudoProgramaticoEvento: any[] = [];
  @Input() listaInstrutorCargaHoraria: any[] = [];
  @Output() listaInstrutorCargaHorariaChange = new EventEmitter<any>();
  @Input() listaEventoInstrutores: any[] = [];
  @Input() validateForm: any = false;
  @Output() validateFormChange = new EventEmitter<any>();
  @Input() listaParticipantes: any[] = [];
  @Output() listaParticipantesChange: EventEmitter<any> =
    new EventEmitter<any>();
  @Input() edicaoSelecionada: number = 0;
  fileLote: any = null;
  modal_obj: any;

  @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);

  displayPrestarContaModal: boolean = false;
  displayJustificarModal: boolean = false;
  emLote: boolean = false;
  anexo: AnexoPrestacaoConta = new AnexoPrestacaoConta();
  valor: any = {};
  idConteudoProgramatico: number = 0;
  prestar_conta: PrestarContaEvento = new PrestarContaEvento();
  justificar: JustificarEvento = new JustificarEvento();
  prestar_conta_instrutor: PrestarContaEventoInstrutor =
    new PrestarContaEventoInstrutor();
  form_prestacao_conta = null;
  form_justificar = null;

  init() {
    this.form_prestacao_conta = this.formBuilder.group({
      prestar_conta: this.formBuilder.group({
        id_instrutor: [null, [Validators.required]],
        carga_horaria: [null, [Validators.required]],
      }),
      participantes: this.formBuilder.group({
        nome: [null, [Validators.maxLength(255), Validators.required]],
        cpf: [null, ValidCpfORCnpj],
        id_conteudo_programatico_evento: [this.idConteudoProgramatico],
        tipo_inclusao: [2],
        id_edicao_evento: [this.edicaoSelecionada],
      }),
    });
    this.form_justificar = this.formBuilder.group({
      id: [null],
      justificativa: [null, [Validators.maxLength(255)]],
    });

    this.form_prestacao_conta
      .get("participantes.tipo_inclusao")
      .valueChanges.subscribe((item) => {
      if (item === "2") {
        this.emLote = false;
      }
      if (item === "1") {
        this.emLote = true;
      }
    });
  }

  getInstrutorNome(id: number): string {
    const instrutor = this.listaEventoInstrutores.find(item => item.id === id);
    return instrutor ? instrutor.nome : 'Instrutor não encontrado';
  }

  getStatus(value: any): string {
    if (value === null || value === undefined) {
      return 'Pendente';
    }

    if (typeof value === 'string' || Array.isArray(value)) {
      return value.length > 0 ? 'Concluído' : 'Pendente';
    }

    return 'Pendente';
  }

  AddListaInstrutor(form_prestacao_conta: FormGroup, event: any) {
    var valorCargaHorariaLista = 0;
    this.listaInstrutorCargaHoraria.forEach((x) => {
      valorCargaHorariaLista += x.carga_horaria;
    });

    var soma =
      valorCargaHorariaLista +
      form_prestacao_conta.get("prestar_conta.carga_horaria").value;
    var valido = soma > this.modal_obj.evento.carga_horaria ? false : true;
    if (valido) {
      this.addToList(
        this.listaInstrutorCargaHoraria,
        this.listaInstrutorCargaHorariaChange,
        this.form_prestacao_conta.get("prestar_conta"),
        event,
        {
          id_instrutor: form_prestacao_conta.get("prestar_conta.id_instrutor")
            .value,
        }
      );
    } else {
      form_prestacao_conta
        .get("prestar_conta.carga_horaria")
        .setErrors({ error: "Carga horária superior a do evento." });
    }
  }

  dysplayAnexo(btnclick: number) {
    if (btnclick == 1) {
      this.displayIntrutorModal = true;
      this.instrucao = [];
      this.instrucao.push('<strong>1. Utilize o modelo correto:</strong>');
      this.instrucao.push('\tBaixe o modelo padrão clicando no botão "Documento" ao lado de "Instrução";');

      this.instrucao.push('<strong>2. Preencha os dados em uma única coluna:</strong>');
      this.instrucao.push('\tInsira o nome completo do participante, seguido de vírgula (,) e o CPF (11 números) no formato 000.000.000-00 ou 00000000000;');
      this.instrucao.push('\t<strong>Exemplo:</strong>João da Silva,000.000.000-00;');

      this.instrucao.push('<strong>3. Atenção ao preencher:</strong>');
      this.instrucao.push('\t<strong>Comece na linha 2:</strong> A primeira linha é reservada para os títulos das colunas');
      this.instrucao.push('\t<strong>Nome:</strong> Não utilize caracteres especiais como: @, #, $, %, &, *, (, ), !, ?, +, =, etc');
      this.instrucao.push('\t<strong>CPF:</strong> Preencha com todos os 11 números, utilizando um dos dois modelos citados acima');

      this.instrucao.push('<strong>4. Revise antes de enviar:</strong>');
      this.instrucao.push('\tVerifique atentamente todos os dados. Qualquer erro impedirá o processamento');
      
      this.instrucao.push('<strong>5. Salve o arquivo:</strong>');
      this.instrucao.push('\tSalve a planilha no formato CSV UTF-8');
    } else {
      this.service.ObterDocumento(`arquivo/documentoEvento`).subscribe(
        (data) => {
          FileSaver.saveAs(
            this.b64toFile(data, null, "application/octet-stream"),
            "Participantes_Lote.csv"
          );
          this.showMsgSucess(
            `O arquivo Participantes_Lote.csv foi baixado automaticamente, verifique na pasta de downloads.`
          );
        },
        (err) =>
          this.showMsgError(`Houve um erro ao baixar o arquivo. ${err._body}`)
      );
    }
  }
  salvarPrestacaoConta() {
    this.confirmacao.confirm({
      header: "Mensagem de Confirmação",
      message: `Atenção! Ao confirmar esta operação, a Prestação de Contas do Evento será
             ${
        this.acao == "cadastrar" ? "salva" : "atualizada"
      } na base de dados.
            Deseja realmente confirmar esta operação?`,
      accept: () => {
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.prestar_conta.id_edicao_evento = this.edicaoSelecionada;
        this.prestar_conta.edicao_evento = null;
        this.prestar_conta.conteudo_programatico_evento = null;
        this.prestar_conta.prestacao_conta_evento_instrutor = [];
        this.listaInstrutorCargaHoraria.forEach((item) => {
          item.id = 0;
          item.instrutor = null;
          item.prestar_contas_evento = null;
          this.prestar_conta.prestacao_conta_evento_instrutor.push(item);
        });

        this.listaParticipantes = this.listaParticipantes.map((x) => {
          x.cpf = this.limpaCaracterEspecial(x.cpf);
          x.id_edicao_evento = this.edicaoSelecionada;
          x.id_conteudo_programatico_evento = this.idConteudoProgramatico;
          x.conteudo_programatico_evento = null;
          x.edicao_evento = null;
          return x;
        });

        const adicionarPrestacao = () => {
          this.service
            .Adicionar("prestarContasEvento", this.prestar_conta)
            .subscribe(
              () => {
                super.showMsgSucess("Registro salvo com sucesso");
                this.observableUtilPanelDoc.setBlockedPanel(false);
              },
              (err) => {
                super.showMsgWarn(`${err._body}`);
                this.observableUtilPanelDoc.setBlockedPanel(false);
              }
            );
        };

        if (this.listaParticipantes.length > 0) {
          this.service
            .Adicionar(
              "participantesIndividual/salvarLista",
              this.listaParticipantes
            )
            .subscribe(
              () => {
                super.showMsgSucess("Participantes salvos com sucesso");
                if (this.prestar_conta) adicionarPrestacao();
              },
              (err) => {
                super.showMsgError(`Erro ao Gravar. ${err._body}`);
                this.observableUtilPanelDoc.setBlockedPanel(false);
              }
            );
        } else {
          this.prestar_conta.id_edicao_evento = this.edicaoSelecionada;
          adicionarPrestacao()
        }

        this.prestar_conta.edicao_evento = Object.assign(new Edicao(), {
          id: this.edicaoSelecionada,
          id_situacao: Situacoes.Concluído,
        });
      },
    });
  }

  salvarJustificar() {
    this.justificar.id_edicao_evento = this.edicaoSelecionada;
    this.justificar.justificativa =
      this.form_justificar.get("justificativa").value;
    this.justificar.id = this.form_justificar.get("id").value;
    this.service.Adicionar("justificarEvento", this.justificar).subscribe(
      (sucess) => {
        this.dysplayModal(2);
        super.showMsgSucess("Registro salvo com sucesso.");
        location.reload();
      },
      (err) => {
        super.showMsgError(`Erro ao Gravar. ${err._body}`);

        this.observableUtilPanelDoc.setBlockedPanel(false);
      }
    );
  }

  dysplayModal(modal: number, obj: any = null) {
    if (modal === 1) {
      this.displayPrestarContaModal = !this.displayPrestarContaModal;
      if (obj != null) {
        this.modal_obj = obj;
        this.prestar_conta.id_conteudo_programatico_evento = this.modal_obj.id;
        this.idConteudoProgramatico = this.modal_obj.id;
        if (obj.participantes_individual != null)
          this.listaParticipantes = obj.participantes_individual.filter(
            (x) =>
              x.id_conteudo_programatico_evento == this.idConteudoProgramatico
          );
        if (obj.prestar_contas_evento[0] != null) {
          this.prestar_conta = obj.prestar_contas_evento[0];
          this.listaInstrutorCargaHoraria =
            obj.prestar_contas_evento[0].prestacao_conta_evento_instrutor;
        }
      }
    }
    if (modal === 2) {
      this.displayJustificarModal = !this.displayJustificarModal;
      if (obj != null) {
        this.modal_obj = obj;
        this.justificar.id_conteudo_programatico_evento = this.modal_obj.id;
        this.idConteudoProgramatico = this.modal_obj.id;
        if (obj.justificar_evento != null) {
          this.form_justificar.patchValue(obj.justificar_evento[0]);
        }
      }
    }
  }

  addList(event) {
    this.showMsg('warn', 'Mensagem de Alerta', 'Lembre-se de clicar no botão "Salvar" após a inclusão dos participantes.');
    const cpf = this.limpaCaracterEspecial(
      this.form_prestacao_conta.get("participantes.cpf").value
    );
    this.form_prestacao_conta.get("participantes.cpf").setValue(cpf);
    this.addToList(
      this.listaParticipantes,
      this.listaParticipantesChange,
      this.form_prestacao_conta.get("participantes") as FormGroup,
      event,
      { cpf: cpf }
    );
  }

  uploadArquivoLote(event) {
    for (const file of event.files) {
      if (file.size < 10000000) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = (event) => {
          this.valor = {
            filename: file.name,
            filetype: file.type,
            value: fileReader.result.split(",")[1],
            id_prestar_conta: this.edicaoSelecionada,
          };
          this.service.UploadExcel("participantesEvento", this.valor).subscribe(
            (data) => {
              data.forEach((element) => {
                var existe = this.listaParticipantes.find(
                  (x) => x.cpf == this.limpaCaracterEspecial(element.cpf)
                );
                if (existe == null) this.listaParticipantes.push(element);
              });
              this.listaParticipantes.sort((a, b) => a.nome.localeCompare(b.nome));
              this.listaParticipantes = [...this.listaParticipantes];
              this.listaParticipantesChange.emit(this.listaParticipantes);
              this.showMsg('warn', 'Mensagem de Alerta', 'Lembre-se de clicar no botão "Salvar" após a inclusão dos participantes.');
            },
            (err) => {
              this.showMsgError(`${err._body}`);
            }
          );
        };
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/evento-prestacao-conta/crud/etapas/evento-prestacao-conta-etapa5.component.ts